import { AText } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';

import styles from './index.module.css';

const DocRequestedMsg = ({ email }) => {
  const { t } = useI18n();
  const emailAddress = email.split('?')[0];

  return (
    <AText
      className={styles.message}
      dangerouslySetInnerHTML={{
        __html: t(
          'personalOffice.balance.sw.forms.selectCardNumber.additionalVerificationNeeded.warning',
          [`<a href="mailto:${email}">${emailAddress}</a>`]
        )
      }}
    />
  );
};

export default DocRequestedMsg;
